import '../pages/scrim'

window.flags.add('mod-small-header')